var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5.833c.92 0 1.667.747 1.667 1.667l-.001 1.666H17.5a.833.833 0 1 1 0 1.667h-.093l-.754 12.55a.833.833 0 0 1-.832.784H4.214a.833.833 0 0 1-.832-.782L2.597 5.833H2.5a.833.833 0 1 1 0-1.666h3.333V2.5c0-.92.747-1.667 1.667-1.667h5zm3.237 5H4.267l.73 11.667h10.04l.7-11.667zm-7.404 2.5c.46 0 .834.373.834.834v5a.833.833 0 0 1-1.667 0v-5c0-.46.373-.834.833-.834zm3.334 0c.46 0 .833.373.833.834v5a.833.833 0 1 1-1.667 0v-5c0-.46.373-.834.834-.834zM12.5 2.5h-5v1.667h5V2.5z",
    fill: "#585858",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteO);
export default __webpack_public_path__ + "static/media/delete-o.82ad5f6a.svg";
export { ForwardRef as ReactComponent };